<template lang="pug">
b-modal#messageModal.modal.fade(
  centered,
  hide-footer="",
  title="Leave a message",
  tabindex="-1",
  aria-labelledby="messageModal",
  aria-hidden="true"
)
  form
    .form-group
      input#name.form-control.bg-light.border-0(
        type="text",
        placeholder="Name",
        v-model="name"
      )
    .form-group
      input#mail.form-control.bg-light.border-0(
        type="text",
        placeholder="E-mail",
        v-model="email"
      )
    .form-group
      select#inputState.form-control.bg-light.border-0(v-model="location")
        option(value="") Location
        option(:value="country", v-for="(country, index) in countryList") {{ country.name }}
    .form-group
      textarea#message.form-control.bg-light.border-0(
        type="text",
        placeholder="Welcome to messege gadget, let us know if you have any question :",
        v-model="message"
      )
    a.btn.btn-primary.btn-block(@click="submitData") leave messege
</template>

<script>
import { getCountryList } from "@/api/location";
import { contactUsBriefs } from "@/api/contact_us";
export default {
  name: "DialogMessage",
  data() {
    return {
      countryList: [],

      name: "",
      email: "",
      location: "",
      message: "",
    };
  },
  created() {
    this.initialLanguage();
  },
  methods: {
    initialLanguage() {
      this.getCountryList();
    },
    getCountryList() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getCountryList(temp).then((response) => {
        this.countryList = response.data;
        this.restoreSelectedLocation();
      });
    },
    updateCountryList() {
      // 更新 countryList 並保存之前的 location 值
      const previousLocation = this.location;
      this.getCountryList();
      this.savedLocation = previousLocation;
    },
    restoreSelectedLocation() {
      if (this.savedLocation) {
        // 在 countryList 更新後，根據 savedLocation 選擇選項
        this.location =
          this.countryList.find(
            (country) => country.id === this.savedLocation.id
          ) || "";
      }
    },
    submitData() {
      let inputData = {
        name: this.name,
        email: this.email,
        country: this.location.id,
        message: this.message,
      };
      contactUsBriefs(inputData)
        .then(() => {
          alert("send data success!");
          this.name = "";
          this.email = "";
          this.location.id = "";
          this.message = "";
          this.$bvModal.hide("messageModal");
          this.$router.push({
            name: "Home",
          });
        })
        .catch((error) => {
          alert(error.response.data.error);
        });
    },
  },
  watch: {
    "$store.state.user.language": "updateCountryList", // language 變化時調用 getCountryList
  },
};
</script>

<style scoped lang="scss">
.btn-primary {
  background-color: #082b6b;
  border-color: #082b6b;

  &:hover {
    color: #fff;
    background-color: #0069d9;
    border-color: #0062cc;
  }
}

.bg-light {
  background-color: #eee !important;
}

::v-deep .modal-header {
  border: 0;
}

textarea.form-control {
  min-height: 100px;
}

@media only screen and (max-width: 767px) {
  ::v-deep h5 {
    font-weight: 300 !important;
  }
}
</style>
